import React, { useMemo } from 'react';
import { ProductGallery } from '../product/detail/ProductGallery';
import { IProductGalleryImage, ImageComponent } from '../../types/product/productDetailPage';
import { getThumbnailImages, getGalleryImages, getEnlargedImages } from '../product/detail/helpers/ProductGalleryHelper';
import { HelpCenterArticleContent } from '../../types/helpCenter/helpCenter';

interface IHelpCenterProductGalleryProps {
  gallery: HelpCenterArticleContent['gallery'];
  title?: string;
}

const HelpCenterProductGallery = ({ gallery, title }: IHelpCenterProductGalleryProps) => {
  let defaultImages: ImageComponent[] = [];
  let defaultThumbnails: ImageComponent[] = [];
  let defaultenlargedImages: ImageComponent[] = [];
  const { images, thumbnails, enlargedImages } = gallery ?? {};
  if (images) {
    defaultImages = getGalleryImages(images as IProductGalleryImage[]);
  }

  if (thumbnails) {
    defaultThumbnails = getThumbnailImages(thumbnails as IProductGalleryImage[]);
  }

  if (enlargedImages) {
    defaultenlargedImages = getEnlargedImages(enlargedImages as IProductGalleryImage[]);
  }

  const controls = useMemo(() => ({ isNavExpandable: false }), []);
  return (
    <ProductGallery
      imageComponents={defaultImages}
      thumbnailComponents={defaultThumbnails}
      enlargedImageComponents={defaultenlargedImages}
      pageName="help_center_page"
      modalTitle={title || ''}
      controls={controls}
      maxThumbnails={1}
    />
  );
};

export default HelpCenterProductGallery;
